// extracted by mini-css-extract-plugin
export default {"paginationResult":"App_paginationResult__u4RhR","pagination":"App_pagination__EOlIp"};